import { container } from "@di/inversify.config.ts";
import type { EnvironmentClient } from "@iot-platform/core";
import { coreTypes } from "@iot-platform/core";
import { createAigroBranding } from "./aigro.ts";
import type { Branding } from "./branding-context.ts";
import { defaultBranding } from "./default";

const env = container.get<EnvironmentClient>(
    coreTypes.infrastructure.EnvironmentClient,
);
const apiServerURL = env.apiServerUrl;

const brandingConfig: Record<string, Branding> = {
    "staging.aigro.es": createAigroBranding(apiServerURL),
    "www.aigro.es": createAigroBranding(apiServerURL),
    "iot.staging.aigro.es": createAigroBranding(apiServerURL),
    "iot.aigro.es": createAigroBranding(apiServerURL),
    default: defaultBranding(apiServerURL),
};

export default brandingConfig;
